import { t, Trans } from '@lingui/macro';
import { Box, Button, EmptyState } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { Link } from 'react-router-dom';
function FileSystemEmpty() {
    return (<Box flexDirection="column" justifyContent="center">
      <EmptyState withAvatar icon={<Falcon icon="folder"/>} title={t({ message: 'This folder is empty', comment: 'Filesystem: Title for empty state' })} description={t({
            message: 'Be the first one to add documents in here.',
            comment: 'Filesystem: Description for empty state',
        })} actions={<Button appearance="secondary" as={Link} to="/contracts">
            <Falcon icon="plus"/>
            <Trans comment="Filesystem: Create document link">Create document</Trans>
          </Button>}/>
    </Box>);
}
export default FileSystemEmpty;
